module.exports = __webpack_public_path__ + "static/stepguide-5d53bd13b973aaffb639396b327744be.jpg";